import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {Subjects} from "./subjects";


const routes: Routes = [
  {
    path: 'subjects',
    component: Subjects,
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SubjectsRoutingModule {}
